<template>
    <Layout>
        <Header @actions="__headerActions"/>
        <Content>
            <router-view v-bind:lang="language"/>
        </Content>
        <Footer ref="Footer" v-bind:lang="language"/>
        <Modal :footer-hide="true" v-model="commentsModal" width="1170">
            <h1 class="d-block ptb-xl align-center">{{ language === 'zh-cn' ? '联系我们' : 'Contact Us' }}</h1>
            <hr/>
            <div class="d-block p-xl">
                <online-consultative v-bind:lang="language" v-bind:useType="'modal'"/>
            </div>
        </Modal>
    </Layout>
</template>

<script type="text/javascript">
    import Header from '@/components/Header';
    import Footer from "../components/Footer";
    import OnlineConsultative from "../components/OnlineConsultative";

    export default {
        components: {
            Header, Footer, OnlineConsultative
        },
        data () {
            return {
                language: 'zh-cn',
                commentsModal: false,
            }
        },
        beforeDestroy() {
            this.$bus.off('isComments');
        },
        mounted() {
            console.log('当前系统语言----->' + this.$common.language);
            this.$bus.on('isComments', (data) => {
                console.log('isComments----->', data);
                this.commentsModal = data;
            });
        },
        methods: {
            __headerActions(data){
                this.language = data;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/dashboard.vue